module.exports = __webpack_public_path__ + "img/index4.4c8b4ba4.png";